<template>
  <uni-uploader
    multiple
    :title="title"
    :keep-uploaded="false"
    :concurrency="2"
    accept="image/*"
    @queue="files => $emit('checkNewPhotos', files)"
    @uploaded="onUploaded"
  />
</template>

<script>
import UniUploader from './uploader/UniUploader.vue'

/**
 * Photos of an album, one request per photo: each uploaded photo goes to the page (`@input` its id, `@updatePhotos`
 * the file) and leaves the uploader; a failed one stays with «Повторить». `@checkNewPhotos` tells the page that photos
 * were picked.
 *
 * The props and events are the ones the album pages have always used; the uploading itself is UniUploader.
 */
export default {
  name: 'MultiFileUploader',
  components: { UniUploader },
  props: {
    title: { type: String, default: '' },
    value: { type: Number, default: null },
    default: { type: Object, default: null },
  },
  methods: {
    onUploaded(file) {
      this.$emit('input', file.id)
      this.$emit('updatePhotos', file)
    },

  },
}
</script>
